<template>
    <div class="block max-w-4xl bg-gray-100 dark:bg-gray-800">
        <label>
            <span class="text-gray-700 dark:text-gray-200">{{ label }}</span>
        </label>
        <datepicker
            :disabled="disabled"
            :name="name"
            :format="customFormatter"
            :monday-first="true"
            v-model="formattedValue"
            :clear-button="clearButton"
        ></datepicker>
        <error :error="error" />
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';

export default {
    name: "InputDate",
    components: {
        Datepicker
    },
    data(){
        return {
            clientDateFormat: 'DD MMM yyyy',
            serverDateFormat: 'yyyy-MM-DD',
        }
    },
    props: {
        name: String,
        label: String,
        value: [String, Date],
        type: String,
        error: {
            type: String,
            required: false,
        },
        clearButton: {
            type: Boolean,
            required: false,
            default: true,
        },
        disabled: {
            type: Boolean,
            required: false
        }
    },
    methods: {
        customFormatter: function(date) {
            return moment(date).format(this.clientDateFormat);
        }
    },
    computed: {
        formattedValue: {
            get(){
                // if there is a date, update the format and emit so the form has the
                // correct server value if they do not change the date field
                if(this.value){
                    // this.value = moment(this.value).format(this.serverDateFormat);
                    this.$emit('input', moment(this.value).format(this.serverDateFormat));
                }
                return this.value;
            },
            set(date){
                this.$emit('input', date ? moment(date).format(this.serverDateFormat) : null)
            }
        }
    }
};
</script>
